export default __webpack_public_path__ + "static/media/long_left_arrow.734f5c4e.svg";